/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Toggle_PlaybackInputs */



/**
* | output |
* | --- |
* | "Play or pause video playback" |
*
* @param {Shortcut_Keys_Desc_Toggle_PlaybackInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_toggle_playback = /** @type {((inputs?: Shortcut_Keys_Desc_Toggle_PlaybackInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Toggle_PlaybackInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lire ou mettre en pause la lecture video")
	if (locale === "de") return /** @type {LocalizedString} */ ("Videowiedergabe abspielen oder pausieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Riproduci o metti in pausa la riproduzione video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Воспроизвести или приостановить воспроизведение видео")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reproducir o pausar la reproducción del vídeo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("播放或暂停视频播放")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビデオの再生または一時停止")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो प्लेबैक को चलाएं या रोकें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Reproduzir ou pausar a reprodução do vídeo")
	return /** @type {LocalizedString} */ ("Play or pause video playback")
});